// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorHeader-cls1_CNH","cls2":"AuthorHeader-cls2_axC AuthorHeader-cls1_CNH"};